import { i18n } from '@lingui/core';
import { I18nProvider } from '@lingui/react';
import React from 'react';
import { defaultLocale, load } from './i18n.config';

export default function ExtendedI18nProvider({
  locale = defaultLocale,
  children,
  ...rest
}) {
  React.useEffect(() => {
    i18n.activate(locale);
  }, [locale]);
  load(locale);
  if (!locale) console.log('locale is undefined', rest);
  i18n._locale = locale;

  return <I18nProvider i18n={i18n}>{children}</I18nProvider>;
}
